import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import Checkbox from './Checkbox';

const AddressItem = ({ address, isDefault, onSetDefault, onEdit, onDelete }) => {
  const { t } = useTranslation();
  
  return (
    <div className="p-4 relative bg-white rounded-md outline outline-1 outline-[#dddddd] flex flex-col justify-start items-start gap-4 overflow-hidden">
      <div className="self-stretch flex flex-col justify-start items-start gap-3">
        <div className="self-stretch flex text-[#111111] text-sm font-medium leading-[21px] gap-2">
          <div className='flex-1 overflow-hidden line-clamp-1'>
            {address.lastname} {address.firstname} {address.contactNumber}
          </div>
          {isDefault && (
            <div className="h-5 min-w-16 px-1 py-px inline-flex bg-[#2a66ff]/10 rounded-sm flex justify-center items-center text-center text-[#2966ff] text-xs leading-[18px]">
              {t('address.defaultDelivery')}
            </div>
          )}
        </div>
        <div className="self-stretch flex flex-col justify-start items-start gap-6">
          <div className="self-stretch text-[#111111] text-sm font-normal leading-[21px]">
            〒{address.postalCode}
            <br />
            {address.prefecture} {address.city} {address.address1} {address.address2}
          </div>
        </div>
      </div>
      
      
      <div className="self-stretch flex justify-start items-center gap-2">
        <Button 
          onClick={() => onEdit(address)} 
          size="s"
        >
          {t('common.edit')}
        </Button>
        
        <Button 
          onClick={() => onDelete(address)} 
          size="s"
        >
          {t('common.delete')}
        </Button>
        
        <div className="flex-1 flex justify-end items-center gap-1">
          <Checkbox
            checked={isDefault}
            onCheckedChange={() => !isDefault && onSetDefault(address)}
            size={4}
          />
          <div className="text-[#666666] text-xs font-normal">
            {t('address.setAsDefault')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressItem; 